import { AssetType } from "../enums/asset-type.enum";

const assetTypeLabels: Record<AssetType, string> = {
  [AssetType.Truck]: 'Trucks',
  [AssetType.Plane]: 'Planes',
  [AssetType.Boat]: 'Boats',
  [AssetType.Trailer]: 'Trailers',
  [AssetType.Car]: 'Cars',
  [AssetType.Motorbike]: 'Motorbikes',
  [AssetType.Generator]: 'Generators',
  [AssetType.Wagon]: 'Wagons',
  [AssetType.ATG]: 'ATG',
  [AssetType.YellowEquipment]: 'Yellow Equipment',
  [AssetType.Container]: 'Containers',
  [AssetType.SkyVault]: 'SkyVault',
  [AssetType.Van]: 'Vans'
};

export function getAssetTypeLabel(assetType: AssetType): string {
  return assetTypeLabels[assetType];
}